<template>
  <login-wrap
    id="login2fa"
    :title="string.title"
    :text="string.text">
    <valid-form
      class="verification-code-form"
      @submit="loginAction">
      <verification-code-input
        v-model="code"
        :aria-label="string.title"
        class="mb-4" />
      <qx-button
        id="login-2fa"
        :title="string.loginButtonLabel"
        :is-block="true"
        :in-progress="inProgress"
        type="submit"
        state="active" />
    </valid-form>
    <another-account />
  </login-wrap>
</template>

<script>
import { mapMutations } from 'vuex';
import { Form as ValidForm } from 'vee-validate';

import LoginWrap from '@/components/auth/LoginWrap.vue';
import anotherAccount from '@/elements/auth/anotherAccount.vue';
import qxButton from '@/elements/button.vue';
import VerificationCodeInput from '@/elements/VerificationCodeInput.vue';

import { mfaLogin } from '@/api';
import { INVALID_2FA_CODE } from '@/utils/cons';
import EventBus from '@/elements/eventBus.js';

export default {
  name: 'LoginTwoFA',
  components: {
    anotherAccount,
    qxButton,
    LoginWrap,
    ValidForm,
    VerificationCodeInput,
  },
  emits: ['successLogin'],
  data() {
    return {
      inProgress: false,
      code: '',
    };
  },
  computed: {
    string() {
      return {
        title: this.$gettext('Two-factor authentication'),
        text: this.$gettext('Check your authentication app for a sign-in code for Quatrix') + '.',
        loginButtonLabel: this.$gettext('Log in'),
      };
    },
  },
  methods: {
    ...mapMutations({
      setLoginError: 'auth/setLoginError',
    }),
    async loginAction() {
      if (this.inProgress) {
        return;
      }
      this.inProgress = true;

      try {
        const { status } = await mfaLogin({
          auth_type: '2FA',
          code: this.code,
        });
        if (status === 200) {
          this.$emit('successLogin');
        }
      } catch (error) {
        if (error?.response?.status === 401 && error?.response?.data?.code === INVALID_2FA_CODE) {
          this.setLoginError('wrong2faCode');
        } else {
          EventBus.$emit('handle-error', { response: error?.response });
        }
      } finally {
        this.inProgress = false;
      }
    },
  },
};
</script>
